import React, { useState } from "react";
import "./ContactSection.css";
import { useTranslation } from "react-i18next";

import contactIcon from "../Assets/contact-icon.png";
import callPerson from "../Assets/call-person.png";

export default function ContactSection({ id }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";

  // Form state
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("complaint");
  const [message, setMessage] = useState("");

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim() || !message.trim()) {
      alert("Please fill in Name and Message.");
      return;
    }

    // Prepare form data
    const formData = {
      name,
      email,
      phone,
      subject,
      message,
    };

    try {
      const res = await fetch("https://cmpranesh-admk.com/Mail/send-whatsapp.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        alert(
          lang === "en"
            ? "Message sent successfully!"
            : "செய்தி வெற்றிகரமாக அனுப்பப்பட்டது!"
        );
        // Reset form
        setName("");
        setEmail("");
        setPhone("");
        setSubject("complaint");
        setMessage("");
      } else {
        alert(
          lang === "en"
            ? "Failed to send message: " + data.error
            : "செய்தியை அனுப்ப முடியவில்லை: " + data.error
        );
      }
    } catch (error) {
      console.error(error);
      alert(
        lang === "en"
          ? "Error sending message."
          : "செய்தியை அனுப்பும் போது பிழை ஏற்பட்டது."
      );
    }
  };

  return (
    <section id={id} className="cm-contact-wrapper">
      <div className="cm-contact-container">

        {/* LEFT SIDE */}
        <div className="cm-contact-left">
          <img src={contactIcon} alt="Icon" className="cm-contact-main-icon" />
          <h2 className="cm-contact-title">{t("contact_title")}</h2>
          <p className="cm-contact-desc">{t("contact_description")}</p>

          <div className="cm-contact-call-box">
            <img src={callPerson} alt="Call" className="cm-contact-call-img" />
            <div>
              <p className="cm-call-label">{t("contact_call_label")}</p>
              <p className="cm-call-number">+91 99446 62747</p>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE FORM */}
        <div className="cm-contact-right">
          <form className="cm-contact-form" onSubmit={handleSubmit}>

            <div className="cm-form-row">
              <div className="cm-form-group">
                <label>{t("contact_form_name")}</label>
                <input
                  type="text"
                  placeholder={t("contact_form_name_placeholder")}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="cm-form-group">
                <label>{t("contact_form_email")}</label>
                <input
                  type="email"
                  placeholder={t("contact_form_email_placeholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="cm-form-row">
              <div className="cm-form-group">
                <label>{t("contact_form_phone")}</label>
                <input
                  type="text"
                  placeholder={t("contact_form_phone_placeholder")}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="cm-form-group">
                <label>{t("contact_form_subject")}</label>
                <select value={subject} onChange={(e) => setSubject(e.target.value)}>
                  <option value="complaint">{t("contact_form_subject_complaint")}</option>
                  <option value="feedback">{t("contact_form_subject_feedback")}</option>
                </select>
              </div>
            </div>

            <div className="cm-form-group cm-form-full">
              <label>{t("contact_form_message")}</label>
              <textarea
                placeholder={t("contact_form_message_placeholder")}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>

            <p className="cm-form-note">{t("contact_form_note")}</p>

            <button type="submit" className="cm-submit-btn">
              {t("contact_form_submit")}
            </button>
          </form>
        </div>

      </div>
    </section>
  );
}
